import React from 'react'
import { PopoverFilter, DatePickerRange } from '~/components/shared'

interface CalendarFilterProps {
  isActive: boolean
  dates?: Date[]
  onChange: (dates: Date[]) => void
}

export const CalendarFilter = ({ dates, isActive, onChange }: CalendarFilterProps): JSX.Element => {
  return (
    <PopoverFilter active={isActive} iconName="dateRange" svgFilled tooltipDescription="Selecionar data">
      <DatePickerRange
        date={dates}
        setPeriod={onChange}
        buttonsDefinedPeriods={[
          { label: '1 mês', returnInMonths: 0.2 },
          { label: '3 meses', returnInMonths: 3 },
          { label: '6 meses', returnInMonths: 6 },
          { label: '1 ano', returnInMonths: 12 }
        ]}
      />
    </PopoverFilter>
  )
}
